<template>
	<div>
		<!-- 头部导航栏 -->
		<div
			class="head-bar po-r"
			@mouseover="hover = true"
			@mouseleave="leave"
			:class="{ 'box-sha': shadow }"
			id="head-bar"
			:style="(color == 'white' ? 'color:#fff;' : 'color:#000;') + background"
		>
			<div class="content head-bar-content" style="z-index: 9999;">
				<!-- logo,点击回首页 -->
				<img
					class="logo cp"
					:src="`https://imgtest.togy.com.cn/oyjj/langGuo/${color == 'white' ? 'logo_white' : 'logo_red'}.png`"
					@click="$router.push({ name: 'HomePage' })"
				/>

				<div class="flex-cr fs-16" style="flex: 1;" :class="is_phone ? 'hide' : 'show'">
					<span style="flex: 3;"></span>
					<!-- 一级菜单 -->
					<div class="head-bar-item" v-for="(v, i) in menu_list" :key="i" @click="clickMenu(v)" @mouseenter="$store.commit('setShowSolution', i)">{{ v.title }}</div>
					<span style="flex: 2;"></span>
					<!-- 语言切换 -->
					<el-dropdown class="cp ptb-10 flex-c" @command="handleCommand">
						<span class="fs-16 mr-5" :class="{ 'co-w': color == 'white' }">{{ $store.state.language }}</span>
						<img style="width: .1rem;" src="../assets/img/down_icon_white.png" alt="" />
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="v" v-for="(v, i) in ['EN', 'CN']" :key="i">{{ v }}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<!-- 缩略菜单按钮 -->
				<div class="fs-20 p-20 cp" :style="is_phone ? '' : 'display:none;'" @click="show_phone_menu = !show_phone_menu">三</div>
			</div>
			<slot></slot>
			<!-- 子菜单 -->
			<div class="solution content" style="justify-content: space-between;" :style="menu_chile.length ? 'height:4rem;z-index:200;' : 'height:0;'">
				<div class="ptb-40" v-for="(item, index) in menu_chile" :key="index">
					<div class="fs-16 pb-20">{{ item.name }}</div>
					<div class="solution-item fs-14 cp" :class="{ black: color == 'black' }" v-for="(v, i) in item.childrenList" :key="i" @click="clickMenu(v)">{{ v.title }}</div>
				</div>
			</div>
		</div>
		<!-- 占位 -->
		<div :style="'height:' + height + 'px'" v-if="hint"></div>

		<!-- 手机端菜单 -->
		<div class="phone-menu prl-20" :style="(show_phone_menu ? `height:calc(100vh - ${height}px);` : '') + `top:${height}px;`">
			<div class="ptb-20" v-for="(v, i) in menu_list" :key="i">
				<!-- 一级菜单 -->
				<div class="flex-c" @click.stop="clickPhoneMenu(v, i, 'menu_index1')">
					<div class="flex1 h1 fs-w">{{ v.title }}</div>
					<rightIcon v-if="v.childrenList && v.childrenList.length" :select="menu_index1 == i"></rightIcon>
				</div>

				<div class="fs-14 pt-20 pl-40" v-show="menu_index1 == i">
					<!-- 二级菜单 -->
					<div
						:class="ind != v.childrenList.length - 1 ? 'bor-bf2' : ''"
						v-for="(val, ind) in v.childrenList"
						:key="ind"
						@click.stop="clickPhoneMenu(val, ind, 'menu_index2')"
					>
						<div class="flex-c ptb-20">
							<div class="flex1 h2 fs-w">{{ val.name }}</div>
							<rightIcon v-if="val.childrenList && val.childrenList.length" :select="menu_index2 == ind"></rightIcon>
						</div>

						<div v-for="(value, index) in val.childrenList" :key="index" v-show="menu_index2 == ind">
							<!-- 三级菜单 -->
							<div class="flex-c pl-40 fs-12 pt-15">
								<div class="ptb-3 lh-30 fs-w" @click.stop="clickPhoneMenu(value, index,'tab')">{{ value.title }}</div>
								<!-- <rightIcon v-if="value.childrenList && value.childrenList.length" :select="menu_index3 == index"></rightIcon> -->
							</div>
							<!-- 四级菜单 -->
							<!-- <div class="pl-40 fs-12 pt-15" v-show="menu_index3 == index">
								<div class="ptb-3 lh-30 fs-w" v-for="(e, k) in value.childrenList" :key="k" @click.stop="clickPhoneMenu(e, k)">{{ e.title }}</div>
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'head-bar',
	props: {
		color: { default: 'white' }, //默认白色，black黑色
		hint: { default: false }, //是否占位
		shadow: { default: false } //是否显示阴影
	},
	data() {
		return {
			hover: false, //鼠标是否在菜单上，是的时候需要变黑
			show_phone_menu: false,
			height: 0,
			menu_list: [],
			menu_index1: 0,
			menu_index2: -1,
			menu_index3:-1,
		};
	},
	computed: {
		// 头部背景色
		background() {
			let opcaty = this.$store.state.scroll_height > 5 || this.hover ? 0.85 : 0;
			return 'background:' + (this.color == 'white' ? `rgba(0,0,0,${opcaty})` : `rgba(255,255,255,${opcaty})`);
		},
		// 一级菜单下的二级菜单
		menu_chile() {
			if (this.$store.state.show_solution == -1) return [];
			return this.menu_list[this.$store.state.show_solution].childrenList || [];
		}
	},
	created() {},
	mounted() {
		this.$nextTick(() => this.getHeight());
		window.onresize = () => {
			this.getHeight();
		};
		this.$getMenu.then(res => {
			this.menu_list = res;
			console.log(this.menu_list,"导航菜单")
		});
	},
	methods: {
		// 点击菜单
		clickMenu(v) {
			if (!v.url_name && !v.url) return;
			this.$router.push({name:v.url_name || v.url});
		},
		// 鼠标离开头部栏
		leave() {
			this.hover = false;
			this.$store.commit('setShowSolution', -1);
		},
		// 获取高度
		getHeight() {
			this.height = document.getElementById('head-bar').offsetHeight;
			this.$store.commit('setHeadBarHeight', this.height);
		},
		// 切换语言
		handleCommand(language) {
			this.$store.commit('setLanguage', language);
		},
		// 点击手机菜单
		clickPhoneMenu(value, index, type) {
			if(type == 'tab'){
				this.show_phone_menu = false
				let a = document.createElement('a');
				a.href = window.location.href.substr(0,window.location.href.indexOf('#')) + '#/' +value.url;
				a.click();
				a.remove();
			}else {
				if (value.childrenList && value.childrenList.length) {
					this[type] = this[type] == index ? -1 : index;
				} else if (value.url) {
					this.show_phone_menu = false;
					let a = document.createElement('a');
					a.href = window.location.href.substr(0,window.location.href.indexOf('#')) + '#/' +value.url_name;
					a.click();
					a.remove();
					// this.$router.push({ name: value.path_name });
				}
			}
		}
	}
};
</script>

<style scoped="scoped">
/* 解决方案 */
.solution {
	display: flex;
	align-items: flex-start;
	/* background-color: rgba(0, 0, 0, 0.85); */
	z-index: 103;
	transition: all 0.3s;
	overflow: hidden;
	position: relative;
	top: -2px;
}
.solution-more {
	width: 0.15rem;
	height: auto;
	transition: all 0.2s;
	margin-left: 0.05rem;
}
.solution-item {
	color: #868686;
	padding: 0.17rem 0.14rem 0.17rem 0;
}

.solution-item:hover::before {
	content: '';
	display: inline-block;
	width: 0.07rem;
	height: 0.07rem;
	border-radius: 50%;
	background-color: #ffffff;
	margin-right: 0.07rem;
}

.solution-item:hover {
	color: #ffffff;
	padding-right: 0;
}
.black:hover {
	color: #333;
	padding-right: 0;
}
.black:hover::before {
	background-color: #333;
}
.phone-menu {
	z-index: 200;
	position: fixed;
	width: 100vw;
	background-color: rgba(255, 255, 255, 1);
	height: 0vh;
	transition: all 0.3s;
	overflow: hidden;
}
.hide {
	animation: hide 1s;
	animation-iteration-count: 1;
	animation-fill-mode: forwards;
}
@keyframes hide {
	30% {
		transform: translateX(-10%);
	}
	100% {
		transform: translateX(150%);
		display: none;
		width: 0;
		flex: 1;
		overflow: hidden;
	}
}
.show {
	animation: show 1s;
	animation-iteration-count: 1;
	animation-fill-mode: forwards;
}
@keyframes show {
	0% {
		transform: translateX(150%);
	}
	70% {
		transform: translateX(-10%);
	}
	100% {
		transform: translateX(0%);
	}
}
.san {
	z-index: 1;
}
.head-bar {
	position: fixed;
	width: 100%;
	top: 0;
	/* left: 50%;
	transform: translateX(-50%); */
	font-size: 0.16rem;
	z-index: 100;
}
.head-bar-content {
	display: flex;
	align-items: center;
	height: 0.88rem;
	box-sizing: border-box;
}
.logo {
	width: 1.79rem;
	height: auto;
	animation: left 1s;
	animation-iteration-count: 1;
	animation-fill-mode: forwards;
}
@keyframes left {
	from {
		transform: translateX(-4rem);
	}
	to {
		transform: translateX(0);
	}
}

.head-bar-item {
	padding-left: 0.25rem;
	padding-right: 0.25rem;
	cursor: pointer;
	transition: all 0.3s;
}
.head-bar-item:hover {
	opacity: 0.75;
}
/* .head-bar-item:hover, */
.head-bar-item-active {
	color: #d81216;
	font-weight: bold;
}
.cart-img {
	width: 0.2rem;
}

.head-bar-line {
	height: 0.1rem;
	width: 1px;
	margin: 0 0.16rem;
}

.language {
}
</style>



// WEBPACK FOOTER //
// src/components/headBar.vue